import { NgModule, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SystemIcon } from '@rtr-factory/utils/icons';

@NgModule()
export class IconRegistryModule {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  constructor() {
    const icons: SystemIcon[] = [
      { name: 'upload-sm' },
      { name: 'copy-sm' },
      { name: 'delete-sm' },
      { name: 'regenerate-sm' },
      { name: 'download-sm' },
      { name: 'toast-success' },
      { name: 'toast-error' },
      { name: 'down-sm' },
      { name: 'up-sm' },
      { name: 'close-sm' },
      { name: 'edit-sm' },
      { name: 'chevron-down-sm' },
      { name: 'chevron-up-sm' },
      { name: 'chevron-right-sm' },
      { name: 'chevron-left-sm' },
      { name: 'check-sm' },
      { name: 'profile-sm' },
      { name: 'add-sm' },
      { name: 'mail-sm' },
      { name: 'prompt-chain' },
      { name: 'context-menue-sm' },
      { name: 'hamburger-menu' },
      { name: 'media-upload-sm' },
      { name: 'rtr-icon' },
      { name: 'textfile-sm' },
      { name: 'audio-sm' },
      { name: 'video-sm' },
      { name: 'send-sm' },
      { name: 'calendar-sm' },
      { name: 'help-sm' },
      { name: 'filter-sm' },
      { name: 'search-sm' },
      { name: 'navigation-up' },
      { name: 'navigation-down' },
      { name: 'arrow-left' },
      { name: 'image-sm' },
    ];

    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/${icon.name}.svg`),
      );
    });
  }
}
